module.exports = __webpack_public_path__ + "static/media/persona_empty.788e944c.svg";